import apiProxy from "@shared/utils/api-proxy.ts";
import { OriginalResponse } from "./response.ts";
import { RequestType } from "./request.ts";

export default async (request: RequestType) => {
  try {
    const response: OriginalResponse | null = await apiProxy.post(
      `usage-exposer/getSubscriptionsUsageForEntitlements`,
      request,
    );

    if (!response) {
      console.error("Error while fetching usage, got no response");
      return [];
    }
    return response.subscriptions;
  } catch (e) {
    console.error("Error while fetching usage", e);
    return [];
  }
};
